import { DsPromoBannerNewDto } from "@sazka/design-system/src/promo-banner/ds-promo-banner-new";
import { httpClient } from "../http-client";
import { ExtraGameShopItemModel } from "../models/extra-game-shop-item-model";
import { PlayerExtraGameTickets } from "../models/player-extra-game";

export async function getStandaloneWheelBanner(): Promise<DsPromoBannerNewDto> {
    const response = await httpClient.get<DsPromoBannerNewDto[]>(
        `/promo/banners?promoSpaceId=sazka-klub-standalone&count=1`
    );
    return response?.data?.length ? response.data[0] : null;
}

export async function getExtraGamePosList(): Promise<ExtraGameShopItemModel[]> {
    const response = await httpClient.get<ExtraGameShopItemModel[]>("kasa/extra-game/pos-list");

    return response.data;
}

export async function fetchPlayerExtraGameTickets(): Promise<PlayerExtraGameTickets> {
    try {
        const response = await httpClient.get<PlayerExtraGameTickets>(`/kasa/player/extra-game-tickets`);
        return response.data;
    } catch (error: any) {
        return error.response;
    }
}
